import React from 'react'
import { useTranslation } from 'react-i18next'
import { HeartPulse } from 'lucide-react'
import { VitalsPanel } from './VitalsPanel'

// Vitals section on HealthProfilePage — three stacked sub-panels, one
// per kind. Each panel fetches its own slice of vital_entries; cheap
// because the page only renders this once per visit.
export function VitalsSection() {
  const { t } = useTranslation()
  return (
    <section className="space-y-2 pt-2">
      <div className="flex items-center justify-between px-1">
        <h2 className="text-sm font-semibold text-foreground flex items-center gap-1.5" dir="auto">
          <HeartPulse className="w-4 h-4 text-app-primary-500" />
          {t('healthProfile.vitals.title')}
        </h2>
      </div>
      <VitalsPanel kind="blood_pressure" />
      <VitalsPanel kind="heart_rate" />
      <VitalsPanel kind="glucose" />
    </section>
  )
}
